enum OrderTableColumnsType {
    /** 复选框（不可操作） */
    CHECKBOX = "CHECKBOX",

    /** 状态 */
    STATUS = "STATUS",

    /**
     * 店铺信息
     */
    SHOP_INFO = "SHOP_INFO",

    /** 订单编号 */
    ORIGINAL_ID = "ORIGINAL_ID",

    /** 代理商 */
    RETAILER = "RETAILER",

    /**买家昵称 */
    BUYER_USERNAME = "buyerUsername",

    /** 数量 */
    QUANTITY = "QUANTITY",

    /** 实付 */
    PAYMENTS = "PAYMENTS",

    /** 商品 */
    PRODUCT = "PRODUCT",

    /**定制信息 */
    CUSTOMIZATION_INFO = "CUSTOMIZATION_INFO",

    /**下单时间 */
    ORDER_TIME = "ORDER_TIME",

    /**付款时间 */
    PAYMENT_TIME = "PAYMENT_TIME",

    /** 剩余发货时间 */
    SHIPPING_DEADLINE = "SHIPPING_DEADLINE",

    /**发票信息 */
    INVOICE_INFO = "INVOICE_INFO",

    /** 收货人 */
    CONSIGNEE = "CONSIGNEE",

    ORDER_REMARK = "ORDER_REMARK",

    /**发货时间 */
    SHIPPING_TIME = "SHIPPING_TIME",

    /** 运单号 */
    WAYBILL_NO = "WAYBILL_NO",

    /** 代发信息(代理商视角) */
    SUPPLIER_DROPSHIPPING2 = "SUPPLIER_DROPSHIPPING2",

    /**打印流水号 */
    SEQUENCE_NO = "SEQUENCE_NO",

    /**订单重量 */
    WEIGHT = "WEIGHT",

    /**发货人 */
    SHIPPER = "SHIPPER",

    /** 预估配送时效 */
    LOGISTICS_AGING_PREDICT = "LOGISTICS_AGING_PREDICT",

    /** 快递推荐 */
    LOGISTICS_RECOMMEND = "LOGISTICS_RECOMMEND",

    /** 实收 */
    SELLER_RECEIPTS = "SELLER_RECEIPTS",

    /**单打操作 */
    QUICK_OPERATION = "QUICK_OPERATION",

    /** 操作列 */
    OPERATION = "OPERATION",
}

export default OrderTableColumnsType;
